import { Button, ButtonProps } from "@chakra-ui/react";

interface Props extends ButtonProps {
  children: any;
}

export const ButtonPrimary = ({ children, ...rest }: Props) => {
  return (
    <Button
      bgColor={"red.400"}
      color={"white"}
      size={["sm", null, "md"]}
      _hover={{ bgColor: "red.300" }}
      {...rest}
    >
      {children}
    </Button>
  );
};
